export interface IState {
  estimateList: any;
  singleEstimate: any;
  estimateCount: any;
  estimateLastDataId: any;
  estimateDetails: any;
  estimateChangeOrderList: any;
  estimateForChangeOrder: any;
  paymentTermsList: any;
  main_estimate_data: any;
  leadAndCustmerData: any;
  estimateListingOnlyData: any;
}

type Action = any;

export const estimateReducer = (
  state: IState = {
    estimateList: [],
    singleEstimate: {},
    estimateCount: 0,
    estimateLastDataId: null,
    estimateDetails: null,
    estimateChangeOrderList: null,
    estimateForChangeOrder: null,
    paymentTermsList: [],
    main_estimate_data: null,
    leadAndCustmerData: [],
    estimateListingOnlyData: [],
  },
  action: Action
): any => {
  switch (action.type) {
    case "GET_ESTIMATE":
      return {
        ...state,
        estimateList:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.estimateList, ...action?.payload?.data],
        estimateCount: action?.payload?.count,
      };
    case "GET_ESTIMATE_LIST":
      return {
        ...state,
        estimateListingOnlyData:
          action?.payload?.page == 1
            ? action?.payload?.data
            : [...state?.estimateListingOnlyData, ...action?.payload?.data],
        estimateCount: action?.payload?.count,
      };

    case "GET_SINGLE_ESTIMATE":
      return {
        ...state,
        singleEstimate: action?.payload,
      };
    case "GET_SINGLE_ESTIMATE_ID":
      const newEsNumber = Number(action?.payload) + 1;
      return {
        ...state,
        estimateLastDataId: newEsNumber ?? 1,
      };
    case "GET_ESTIMATE_DETAILS":
      return {
        ...state,
        estimateDetails: action?.payload,
      };
    case "GET_MAIN_ESTIMATE_DETAILS":
      return {
        ...state,
        main_estimate_data: action?.payload,
      };

    case "ESTIMATE_CHANGE_ORDERS_LIST":
      return {
        ...state,
        estimateChangeOrderList: action?.payload,
      };
    case "ESTIMATE_FOR_CHANGE_ORDER":
      return {
        ...state,
        estimateForChangeOrder: action?.payload,
      };

    case "GET_PAYMENT_TERMS":
      return {
        ...state,
        paymentTermsList:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.paymentTermsList, ...action?.payload?.data],
      };
    case "UPDATE_TERMS":
      return {
        ...state,
        paymentTermsList: state?.paymentTermsList?.map((elem: any) => {
          if (elem?._id == action?.payload?._id) {
            return action?.payload;
          }
          return elem;
        }),
      };
    case "DELETE_TERMS":
      return {
        ...state,
        paymentTermsList: state?.paymentTermsList?.filter((elem: any) => elem?._id !== action?.payload),
      };
    case "RESTORE_PERMENENT_DELETE_TERMS":
      return {
        ...state,
        paymentTermsList: state?.paymentTermsList?.filter((elem: any) => elem?._id !== action?.payload),
      };

    case "GET_LEADS_AND_CUSTMERS_BOTH":
      return {
        ...state,
        leadAndCustmerData:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.leadAndCustmerData, ...action?.payload?.data],
      };
    case "CLEAR_ESTIMATE_DETAILS":
      return {
        ...state,
        estimateDetails: null,
      };
    case "CLEAR_ALL_ESTIMATE_STATE":
      return {
        ...state,
        estimateDetails: null,
        estimateChangeOrderList: null,
        estimateForChangeOrder: null,
      };
    case "UPDATE_CUSTOMER_SIGN_AFTER_APPROVE":
      return {
        ...state,
        main_estimate_data: {
          ...state?.main_estimate_data,
          status: 4,
          customer_action: {
            ...state?.main_estimate_data?.customer_action,
            is_signed: 1,
            signed_at: new Date(Date.now()),
            signed_url: action?.payload?.sign_url,
          },
        },
      };
    case "UPDATE_STAGE_PAYMENT_WORK_ORDER":
      return {
        ...state,
        estimateDetails:
          state?.estimateDetails?._id == action.payload?.estimateId
            ? {
                ...state?.estimateDetails,
                payment_stages: state?.estimateDetails?.payment_stages?.map((elem: any) => {
                  if (elem?._id == action?.payload?.data?._id) {
                    return { ...action?.payload?.data };
                  }
                  return elem;
                }),
              }
            : state?.estimateDetails,
        main_estimate_data:
          state?.main_estimate_data?._id == action.payload?.estimateId
            ? {
                ...state?.main_estimate_data,
                payment_stages: state?.main_estimate_data?.payment_stages?.map((elem: any) => {
                  if (elem?._id == action?.payload?.data?._id) {
                    return action?.payload?.data;
                  }
                  return elem;
                }),
              }
            : state?.main_estimate_data,
        // estimateChangeOrderList: null,
        // estimateForChangeOrder: null,
      };
    default:
      return state;
  }
};
